// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"360":"2e33aae1","930":"a3c60c44"}[chunkId] + ".js";
};